import {Keys} from "@/constants/key";
import {Scene} from "phaser";
import CU from "@/utils/c-u";

export default class ParticleUtils {

    private static readonly PARTICLE_LIFETIME: number = 900;

    public static showParticleWave(scene: Scene, x: number, y: number, scale: number = 1, depth: number = 0): void {

        if (scene) {

            let particle = scene.add.particles(0, 0, Keys.IMG_PARTICLE_CIRCLE, {
                blendMode: 'ADD',
                scale: { start: 0.07 * scale * CU.S, end: 0.28 * scale * CU.S },
                speed: 1,
                lifespan: ParticleUtils.PARTICLE_LIFETIME,
                frequency: 5,
                maxParticles: 1,
                alpha: { start: 0.3, end: 0 },
                x: x,
                y: y
            }).setDepth(depth);

            scene.time.delayedCall(this.PARTICLE_LIFETIME, function() {
                if(particle) {particle.destroy();}
            });
        }
    }
}